
<template>
  <div class="applicationType">
    <div class="applicationType-main">
      <module-title title="资讯类型管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            添加类型
          </el-button>
        </div>
      </module-title>
      <div class="applicationType-main-contain">
        <div class="applicationType-tree">
          <el-tree
            ref="applicationTypeTree"
            :data="apptypesTree"
            :props="defaultProps"
            :default-expanded-keys="defaultOpen"
            node-key="id"
            highlight-current
            class="filter-tree"
            @node-click="handleNodeClick"
          >
            <span slot-scope="{ node }" class="custom-tree-node">
              <i class="el-icon-menu" />
              {{ node.label }}
            </span>
          </el-tree>
        </div>
        <div class="applicationType-list">
          <el-form
            ref="searchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
            @submit.native.prevent
          >
            <el-form-item label="类型名称" prop="name">
              <el-input
                v-model="searchForm.name"
                maxlength="10"
                name="name"
                size="medium"
                placeholder="请输入类型名称"
                class="handle-form-input"
                clearable
              />
            </el-form-item>
            <el-form-item style="margin-left:50px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="apptypesList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="类型名称" prop="name" align="center" />
            <el-table-column label="类型简介" prop="remark" align="center" show-overflow-tooltip />
            <el-table-column label="最后编辑时间" prop="updateDate" align="center" />
            <el-table-column label="操作" align="left" width="200px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="opAddOrEdit('edit',scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="handleDdelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 新增编辑应用类型 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="handleTitle==='add'?'添加资源类型':'编辑资源类型'"
      width="650px"
      @close="resetForm('handleForm')"
    >
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
        @submit.native.prevent
      >
        <el-form-item label="类型名称：" prop="name">
          <el-input
            v-model="handleForm.name"
            name="name"
            maxlength="10"
            placeholder="请输入类型名称"
            class="handle-form-input"
          />
        </el-form-item>

        <el-form-item label="类型简介：" prop="remark">
          <el-input
            v-model="handleForm.remark"
            name="remark"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            class="handle-form-input"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddSubject"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { validateUserName } from '@/utils/validate';

import { consultingTypTree, consultingtypesList, consultingtypesBatch, consultingtypesAdd, consultingtypesEdit } from '@/api/productOperation/mrDesk/consultingcontents';
export default {
  name: 'InformationTypeManage',

  data() {
    return {
      ajaxLoading: false,
      // 弹框标题
      handleTitle: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false // 添加编辑
      },
      // 搜索表单
      searchForm: {
        name: '',
        pageNum: 1,
        total: 0,
        pageSize: 10,
        status: '',
        pid: ''
      },
      // 操作表单
      handleForm: {
        name: '',
        remark: '',
        pid: '',
        id: ''
      },
      handleRules: {
        name: [
          { required: true, message: '应用类型标题不能为空', trigger: 'blur' },
          { trigger: 'blur', validator: validateUserName }
        ]
      },
      listLoading: false, // 表格刷新loading
      apptypesList: [], //  应用类型列表
      apptypesTree: [], //  应用类型树
      defaultOpen: [], // 默认打开
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  computed: {
    // 学科类别
    subjectTypeList() {
      return [
        {
          id: '',
          name: '全部'
        },
        {
          id: 1,
          name: '自定义'
        },
        {
          id: 0,
          name: '默认'
        }
      ];
    }
  },
  mounted() {
    this.fetchApptypesTree();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApptypesList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApptypesList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchApptypesList();
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.handleTitle = type;
      this.hiddenVariable.dialogEditVisible = true;
      if (type === 'edit') {
        this.handleForm.name = row.name;
        this.handleForm.remark = row.remark;
        this.handleForm.id = row.id;
        this.handleForm.pid = this.searchForm.pid;
      } else {
        this.handleForm.name = '';
        this.handleForm.remark = '';
        this.handleForm.id = '';
        this.handleForm.pid = this.searchForm.pid;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 树点击事件
    handleNodeClick(data, node, el) {
      this.searchForm.pid = data.id;
      this.fetchApptypesList();
    },
    // 新增编辑学科
    handleAddSubject() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          this.handleForm.pid = this.searchForm.pid;
          if (this.handleTitle === 'add') {
            consultingtypesAdd(this.handleForm)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '新增成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.ajaxLoading = false;
                this.fetchApptypesTree();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            consultingtypesEdit(this.handleForm)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.ajaxLoading = false;
                this.fetchApptypesTree();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 删除
    handleDdelete(row) {
      this.$confirm(`确定要删除该资讯类型么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            ids: [row.id],
            status: -1
          };
          return consultingtypesBatch(form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApptypesTree();
        })
        .catch(() => { });
    },

    // 获取应用类型列表
    fetchApptypesList() {
      this.listLoading = true;
      var option = {
        name: this.searchForm.name,
        pid: this.searchForm.pid,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      consultingtypesList(option)
        .then(result => {
          this.apptypesList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.apptypesList = [];
          this.searchForm.total = 0;
        });
    },
    // 获取应用类型列表
    fetchApptypesTree() {
      consultingTypTree()
        .then(result => {
          this.apptypesTree = result.data;
          let defaultKey = '';
          if (!this.searchForm.pid) {
            defaultKey = this.apptypesTree && this.apptypesTree.length ? this.apptypesTree[0].id : '';
            this.searchForm.pid = defaultKey;
          } else {
            defaultKey = this.searchForm.pid;
          }
          this.defaultOpen = [defaultKey];
          this.$nextTick(() => {
            this.$refs.applicationTypeTree &&
              this.$refs.applicationTypeTree.setCurrentKey(defaultKey);
          });
          this.fetchApptypesList();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.applicationType {
  padding-bottom: 20px;
  .applicationType-main {
    .applicationType-main-contain {
      display: flex;
      .applicationType-tree {
        width: 200px;
        margin:0 20px;
        .filter-tree {
          font-size: 15px;
          .custom-tree-node {
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      .applicationType-list {
        width: 80%;
      }
    }
  }
}
.handle-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}
</style>
